export const getContent = (name: string) => {
  return `
      <div class="subway-overlay">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_502_34958)">
            <rect width="20" height="20" rx="10" fill="#FFD857"/>
            <path d="M3.68688 21.6392L9.26327 9.47249H10.7368L16.3132 21.6392H3.68688Z" stroke="black" stroke-width="1.16667"/>
            <rect x="5" y="13.3333" width="10" height="2.83333" fill="#FFD857"/>
            <rect x="5" y="3.33325" width="10" height="11.6667" rx="1.11111" fill="black"/>
            <rect x="6.25" y="4.66626" width="7.5" height="4.16667" rx="0.444444" fill="#FFD857"/>
            <rect x="6.11108" y="11.6667" width="2.22222" height="2.22222" rx="1.11111" fill="#FFD857"/>
            <rect x="11.6667" y="11.6667" width="2.22222" height="2.22222" rx="1.11111" fill="#FFD857"/>
          </g>
          <defs>
            <clipPath id="clip0_502_34958">
              <rect width="20" height="20" rx="10" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        ${name}
      </div>
    `
}
